module.exports = __webpack_public_path__ + "/images/cover-recibiendo-dinero-br.65a0d7e.webp";